import React, { useCallback, useEffect, useState } from "react";
import {
  Row,
  Col,
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
  Card,
  CardHeader,
  CardBody,
} from "reactstrap";
import axios from "axios";
import swal from "sweetalert";
import Select from "react-select";

import Widget from "../../components/Widget/Widget";
import { API_TIMEOUT, LOKASI } from "../../utils";
import { logApp } from "../../utils/func.js";

const initialFetchState = {
  loading: false,
  error: null,
};

const TableLokasi = () => {
  const [lokasiState, setLokasiState] = useState(initialFetchState);
  const [lokasiList, setLokasiList] = useState([]);
  const [listPuskesmas, setListPuskesmas] = useState([]);
  const [allLokasi, setAllLokasi] = useState([]);

  const [lokasiModalOpen, setLokasiModalOpen] = useState(false);

  const [namaLokasi, setNamaLokasi] = useState("");
  const [levelLokasi, setLevelLokasi] = useState("");
  const [idPuskesmas, setIdPuskesmas] = useState("");

  const [editingLokasi, setEditingLokasi] = useState(null);
  const [saving, setSaving] = useState(false);

  const [currentUser, setCurrentUser] = useState();
  const [idLokasi, setIdLokasi] = useState("");
  const [status, setStatus] = useState();
  const [userLevel, setUserLevel] = useState("");

  useEffect(() => {
    if (!currentUser) {
      const user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        setCurrentUser(user);
        setIdLokasi(user.idLokasi);
        setStatus(user.status);
        logApp(user.uid, "Data Lokasi");
      }
    }
  }, []);

  useEffect(() => {
    if (idLokasi) {
      ambilDataLokasiUser();
    }
  }, [idLokasi]);

  useEffect(() => {
    if (userLevel) {
      fetchAllLokasi();
      fetchLokasi();
      if (userLevel === "Dinas" || userLevel === "Puskesmas") {
        fetchPuskesmas();
      }
    }
  }, [userLevel]);

  const fetchAllLokasi = useCallback(async () => {
    try {
      const response = await axios.get(LOKASI + "ambil/", {
        timeout: API_TIMEOUT,
      });
      setAllLokasi(response.data?.data || []);
    } catch (error) {
      console.error("Gagal memuat semua data lokasi", error);
    }
  }, []);

  const ambilDataLokasiUser = () => {
    axios({
      method: "get",
      url: LOKASI + "ambil/",
      timeout: API_TIMEOUT,
    })
      .then((response) => {
        if (response.status !== 200) {
          return "error";
        } else {
          const data = response.data.data;
          if (data.length > 0) {
            const fil = data.filter((item) => {
              return idLokasi == item.id;
            });

            if (fil.length > 0) {
              const level = fil[0].level;
              setUserLevel(level);
            }
          }
        }
      })
      .catch((error) => {
        alert(error);
      });
  };

  const fetchPuskesmas = useCallback(async () => {
    try {
      const response = await axios.get(LOKASI + "ambil/", {
        timeout: API_TIMEOUT,
      });
      const data = response.data?.data || [];

      let puskesmasList = [];

      if (userLevel === "Dinas") {
        // Jika level Dinas, tampilkan semua puskesmas
        puskesmasList = data
          .filter((item) => item.level === "Puskesmas")
          .map((item) => ({
            value: item.id,
            label: item.lokasi,
            color: "primary",
          }));
      } else if (userLevel === "Puskesmas") {
        // Jika level Puskesmas, hanya tampilkan puskesmas dengan id sama dengan idLokasi user
        puskesmasList = data
          .filter((item) => item.level === "Puskesmas" && item.id == idLokasi)
          .map((item) => ({
            value: item.id,
            label: item.lokasi,
            color: "primary",
          }));
      }

      setListPuskesmas(puskesmasList);
    } catch (error) {
      console.error("Gagal memuat data puskesmas", error);
    }
  }, [userLevel, idLokasi]);

  const handleRequestError = useCallback((message, error) => {
    const responseMessage =
      error?.response?.data?.message || message || "Terjadi kesalahan";
    swal("Error", responseMessage, "error");
  }, []);

  const fetchLokasi = useCallback(async () => {
    if (!userLevel) return;

    setLokasiState({ loading: true, error: null });
    try {
      let url = LOKASI;

      if (userLevel === "Dinas") {
        // Jika level Dinas, ambil semua data lokasi
        url = LOKASI;
      } else if (userLevel === "Puskesmas") {
        // Jika level Puskesmas, ambil data lokasi berdasarkan id_puskesmas
        // id_puskesmas adalah id lokasi user itu sendiri (karena puskesmas memiliki id_Puskesmas = null atau id sendiri)
        url = LOKASI + "puskesmas/" + idLokasi;
      }

      const response = await axios.get(url, {
        timeout: API_TIMEOUT,
      });
      setLokasiList(response.data?.data || []);
      setLokasiState({ loading: false, error: null });
    } catch (error) {
      setLokasiState({ loading: false, error });
      handleRequestError("Gagal memuat data lokasi", error);
    }
  }, [userLevel, idLokasi, handleRequestError]);

  const resetLokasiForm = () => {
    setNamaLokasi("");
    setLevelLokasi("");
    setIdPuskesmas("");
    setEditingLokasi(null);
  };

  const toggleLokasiModal = () => {
    setLokasiModalOpen((prev) => !prev);
    if (lokasiModalOpen) {
      resetLokasiForm();
    }
  };

  const handleAddLokasi = () => {
    resetLokasiForm();
    setLokasiModalOpen(true);
  };

  const handleEditLokasi = (item) => {
    setEditingLokasi(item);
    setNamaLokasi(item.lokasi || "");
    setLevelLokasi(
      item.level
        ? {
            value: item.level,
            label: item.level,
            color:
              item.level === "Dinas"
                ? "primary"
                : item.level === "Puskesmas"
                ? "success"
                : "warning",
          }
        : ""
    );

    // Set idPuskesmas dengan label yang benar dari allLokasi atau listPuskesmas
    if (item.id_Puskesmas) {
      const puskesmas = allLokasi.find((lok) => lok.id === item.id_Puskesmas);
      setIdPuskesmas(
        puskesmas
          ? {
              value: puskesmas.id,
              label: puskesmas.lokasi,
              color: "primary",
            }
          : {
              value: item.id_Puskesmas,
              label: `ID: ${item.id_Puskesmas}`,
              color: "primary",
            }
      );
    } else if (userLevel === "Puskesmas" && item.level === "Unit") {
      // Jika userLevel = "Puskesmas" dan item adalah Unit, set dengan idLokasi user
      const puskesmas = allLokasi.find((lok) => lok.id == idLokasi);
      setIdPuskesmas(
        puskesmas
          ? {
              value: puskesmas.id,
              label: puskesmas.lokasi,
              color: "primary",
            }
          : {
              value: idLokasi,
              label: `ID: ${idLokasi}`,
              color: "primary",
            }
      );
    } else {
      setIdPuskesmas("");
    }

    setLokasiModalOpen(true);
  };

  const handleDeleteLokasi = (item) => {
    swal({
      title: "Hapus lokasi?",
      text: `Lokasi "${item.lokasi}" akan dihapus permanen.`,
      icon: "warning",
      buttons: ["Batal", "Hapus"],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (!willDelete) return;
      try {
        await axios.delete(`${LOKASI}${item.id}`, {
          timeout: API_TIMEOUT,
        });
        swal("Sukses", "Data lokasi berhasil dihapus", "success");
        fetchLokasi();
      } catch (error) {
        handleRequestError("Gagal menghapus lokasi", error);
      }
    });
  };

  const handleSaveLokasi = async (event) => {
    event.preventDefault();
    if (!namaLokasi.trim()) {
      swal("Validasi", "Nama lokasi wajib diisi", "warning");
      return;
    }
    if (!levelLokasi || !levelLokasi.value) {
      swal("Validasi", "Level wajib dipilih", "warning");
      return;
    }

    // Jika userLevel = "Puskesmas" dan level yang dipilih = "Unit",
    // otomatis set id_puskesmas dengan idLokasi user
    let idPuskesmasValue = null;
    if (levelLokasi.value === "Unit") {
      if (userLevel === "Puskesmas") {
        // Otomatis set dengan idLokasi user
        idPuskesmasValue = Number(idLokasi);
      } else if (idPuskesmas && idPuskesmas.value) {
        // Jika Dinas, gunakan pilihan user
        idPuskesmasValue = Number(idPuskesmas.value);
      }
    }

    const payload = {
      lokasi: namaLokasi.trim(),
      level: levelLokasi.value,
      id_puskesmas: idPuskesmasValue,
    };

    setSaving(true);
    try {
      if (editingLokasi) {
        await axios.patch(`${LOKASI}${editingLokasi.id}`, payload, {
          timeout: API_TIMEOUT,
        });
        swal("Sukses", "Data lokasi berhasil diperbarui", "success");
      } else {
        await axios.post(LOKASI, payload, {
          timeout: API_TIMEOUT,
        });
        swal("Sukses", "Data lokasi berhasil ditambahkan", "success");
      }
      setSaving(false);
      setLokasiModalOpen(false);
      resetLokasiForm();
      fetchLokasi();
    } catch (error) {
      setSaving(false);
      handleRequestError("Gagal menyimpan lokasi", error);
    }
  };

  // listLevel menyesuaikan level user: jika "Dinas" maka ada "Puskesmas" dan "Unit"
  // jika "Puskesmas" maka hanya "Unit" saja
  const listLevel = (() => {
    if (userLevel === "Dinas") {
      return [
        { value: "Puskesmas", label: "Puskesmas", color: "success" },
        { value: "Unit", label: "Unit", color: "warning" },
      ];
    } else if (userLevel === "Puskesmas") {
      return [{ value: "Unit", label: "Unit", color: "warning" }];
    }
    // default fallback, boleh return kosong/bisa semua options
    return [];
  })();

  const renderLoadingRow = (colSpan) => (
    <tr>
      <td colSpan={colSpan} className="text-center py-4">
        <Spinner size="sm" color="primary" className="mr-2" />
        Memuat data...
      </td>
    </tr>
  );

  const renderEmptyRow = (message, colSpan) => (
    <tr>
      <td colSpan={colSpan} className="text-center py-4 text-muted">
        {message}
      </td>
    </tr>
  );

  // Jangan tampilkan jika status == 3 atau tidak ada idLokasi
  if (status == 3 || !idLokasi) {
    return (
      <div className="lokasi-page">
        <Row>
          <Col>
            <Widget>
              <div className="text-center py-5">
                <p className="text-muted">
                  Anda tidak memiliki akses ke halaman ini.
                </p>
              </div>
            </Widget>
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div className="lokasi-page">
      <Row className="gy-4">
        <Col lg={12} className="mb-4">
          <Widget
            title="Data Lokasi"
            containerClass="shadow-sm border-0"
            className="p-0"
          >
            <Card className="border-0">
              <CardHeader className="bg-transparent border-0 d-flex justify-content-between align-items-center px-3 py-3">
                <span className="mb-0 font-weight-semibold">Daftar Lokasi</span>
                <Button color="primary" size="sm" onClick={handleAddLokasi}>
                  Tambah Lokasi
                </Button>
              </CardHeader>
              <CardBody className="px-3 pb-3">
                <div className="table-responsive">
                  <Table hover className="mb-0">
                    <thead className="thead-light">
                      <tr>
                        <th style={{ width: "5%" }}>No</th>
                        <th style={{ width: "30%" }}>Nama Lokasi</th>
                        <th style={{ width: "15%" }}>Level</th>
                        <th style={{ width: "30%" }}>Puskesmas</th>
                        <th style={{ width: "20%" }} className="text-center">
                          Aksi
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {lokasiState.loading
                        ? renderLoadingRow(5)
                        : lokasiList.length === 0
                        ? renderEmptyRow("Belum ada data lokasi", 5)
                        : lokasiList.map((item, index) => (
                            <tr key={item.id}>
                              <td>{index + 1}</td>
                              <td>{item.lokasi}</td>
                              <td>
                                <span
                                  className={`badge badge-${
                                    item.level === "Dinas"
                                      ? "primary"
                                      : item.level === "Puskesmas"
                                      ? "success"
                                      : "warning"
                                  }`}
                                >
                                  {item.level}
                                </span>
                              </td>
                              <td>
                                {item.id_Puskesmas
                                  ? (() => {
                                      const puskesmas = allLokasi.find(
                                        (lok) => lok.id === item.id_Puskesmas
                                      );
                                      return puskesmas
                                        ? puskesmas.lokasi
                                        : `ID: ${item.id_Puskesmas}`;
                                    })()
                                  : "-"}
                              </td>
                              <td className="text-center">
                                <Button
                                  size="sm"
                                  color="info"
                                  className="mr-2"
                                  onClick={() => handleEditLokasi(item)}
                                >
                                  Edit
                                </Button>
                                <Button
                                  size="sm"
                                  color="danger"
                                  onClick={() => handleDeleteLokasi(item)}
                                >
                                  Hapus
                                </Button>
                              </td>
                            </tr>
                          ))}
                    </tbody>
                  </Table>
                </div>
              </CardBody>
            </Card>
          </Widget>
        </Col>
      </Row>

      <Modal isOpen={lokasiModalOpen} toggle={toggleLokasiModal}>
        <Form onSubmit={handleSaveLokasi}>
          <ModalHeader toggle={toggleLokasiModal}>
            {editingLokasi ? "Edit Lokasi" : "Tambah Lokasi"}
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label for="nama-lokasi">
                Nama Lokasi <span className="text-danger">*</span>
              </Label>
              <Input
                id="nama-lokasi"
                type="text"
                value={namaLokasi}
                onChange={(event) => setNamaLokasi(event.target.value)}
                placeholder="Masukkan nama lokasi"
                required
              />
            </FormGroup>
            <FormGroup>
              <Label for="level-lokasi">
                Level <span className="text-danger">*</span>
              </Label>
              <Select
                id="level-lokasi"
                value={levelLokasi}
                options={listLevel}
                className="react-select"
                classNamePrefix="select"
                isClearable={false}
                onChange={(data) => {
                  setLevelLokasi(data);
                  if (data.value !== "Unit") {
                    setIdPuskesmas("");
                  }
                }}
                required
              />
            </FormGroup>
            {levelLokasi && levelLokasi.value === "Unit" && (
              <FormGroup>
                <Label for="puskesmas-lokasi">Puskesmas</Label>
                {userLevel === "Puskesmas" ? (
                  <Input
                    id="puskesmas-lokasi"
                    type="text"
                    value={
                      allLokasi.find((lok) => lok.id == idLokasi)?.lokasi ||
                      "Puskesmas Anda"
                    }
                    disabled
                    readOnly
                  />
                ) : (
                  <Select
                    id="puskesmas-lokasi"
                    value={idPuskesmas}
                    options={listPuskesmas}
                    className="react-select"
                    classNamePrefix="select"
                    isClearable={true}
                    onChange={(data) => setIdPuskesmas(data || "")}
                    placeholder="Pilih Puskesmas"
                  />
                )}
              </FormGroup>
            )}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={toggleLokasiModal}>
              Batal
            </Button>
            <Button color="primary" type="submit" disabled={saving}>
              {saving ? (
                <>
                  <Spinner size="sm" color="light" className="mr-2" />
                  Menyimpan...
                </>
              ) : editingLokasi ? (
                "Simpan Perubahan"
              ) : (
                "Tambah"
              )}
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default TableLokasi;
